import Logo from 'assets/images/icons/letrus-logo.webp';
import PageLoading from 'components/PageLoading';
import useTerms from 'features/useTerms';
import {Button, Radio} from 'components/ui';
import {FormEvent, useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {
  getUpdateProfileRequestStatus,
  updateProfileRequest,
} from 'store/reducers/profile';
import {
  fetchTermsRequest,
  getTerms,
  getTermsRequestStatus,
} from 'store/reducers/terms';
import {ApplicationState} from 'store/rootReducer';
import {Term} from 'store/services/termsServices';
import {StoreStatus} from 'utils/types/store';
import getFeatureFlag from 'utils/functions/getFeatureFlags';
import {getUserData} from 'utils/functions/getUserData/getUserData';
import styles from './Terms.module.scss';
import TermsSection from './termsSection';

interface DispatchProps {
  updateProfileRequest: typeof updateProfileRequest;
  fetchTermsRequest: typeof fetchTermsRequest;
}

interface StateProps {
  terms: Term[];
  termsRequestStatus: StoreStatus;
  updateProfileRequestStatus: StoreStatus;
}

export type TermsProps = DispatchProps & StateProps;

function Terms({
  terms,
  fetchTermsRequest,
  termsRequestStatus,
  updateProfileRequest,
  updateProfileRequestStatus,
}: TermsProps): JSX.Element {
  const [isLoading, setIsLoading] = useState(true);
  const [readTerms, setReadTerms] = useState(false);

  const navigate = useNavigate();
  const {userProfile, userRoleList} = getUserData();

  const {userTerms, areTermsUpdated} = useTerms({
    terms,
    userProfile,
    userRoles: userRoleList,
    isContest: getFeatureFlag('pilot_terms_student_contest').isOn,
  });

  useEffect(() => {
    fetchTermsRequest();
  }, []);

  useEffect(() => {
    if (termsRequestStatus.fulfilled) {
      if (areTermsUpdated) {
        navigate('/');
      } else {
        setIsLoading(false);
      }
    }

    if (termsRequestStatus.error) {
      // TODO: handle error
    }
  }, [areTermsUpdated, termsRequestStatus]);

  useEffect(() => {
    if (updateProfileRequestStatus.fulfilled) {
      navigate('/');
    }

    if (updateProfileRequestStatus.error) {
      // TODO: handle error
    }
  }, [updateProfileRequestStatus]);

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();

    const termsId = userTerms.map((term) => term.id);

    const termsVersionToUpdate = termsId.reduce((updateList, termId) => {
      const newTerms = terms.find((term) => term.parameter === termId);
      return {
        ...updateList,
        [termId]: newTerms?.value,
      };
    }, {});

    if (termsVersionToUpdate) {
      updateProfileRequest({
        ...termsVersionToUpdate,
        id: userProfile?.id,
      });
    }
  }

  return isLoading ? (
    <PageLoading />
  ) : (
    <div className={styles.wrapper}>
      <form onSubmit={handleSubmit}>
        <div className={styles.terms}>
          <header className={styles.header}>
            <img src={Logo} alt="Letrus" aria-hidden className={styles.logo} />

            <h1 className={styles.title}>Privacidade e termos</h1>
          </header>

          <TermsSection data={userTerms} terms={terms} />
        </div>

        <footer className={styles.formButtons}>
          <Radio
            id="radioInput"
            labelText="Aceito os termos e condições da politica de privacidade da Letrus"
            checked={readTerms}
            onClick={() => setReadTerms(!readTerms)}
          />

          <Button
            variant="primary"
            type="submit"
            size="medium"
            text="Continuar"
            disabled={!readTerms}
            loading={updateProfileRequestStatus.loading}
          />
        </footer>
      </form>
    </div>
  );
}

export default connect(
  (state: ApplicationState) => ({
    terms: getTerms(state),
    termsRequestStatus: getTermsRequestStatus(state),
    updateProfileRequestStatus: getUpdateProfileRequestStatus(state),
  }),
  {
    fetchTermsRequest,
    updateProfileRequest,
  },
)(Terms);
